import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from '../shared/primeng.module';
import { MaterialModuleModule } from '../material-module/material-module/material-module.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { UserPolicyComponent } from '../user-policy/user-policy.component';
import { UserPolicyCommonRouting } from './user-policy-commmon-routing.module';



@NgModule({
  declarations: [
    UserPolicyComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    PrimengModule,
    MaterialModuleModule,
    MatTooltipModule,
    MatTabsModule,
    UserPolicyCommonRouting,

  ]
})
export class UserPolicyCommonModule { }
